import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-navy" data-id="element-50" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-51" data-mp="1uy2xkxid372q">
        <h2 className="font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-52" data-mp="1v05w65xky8j2">
          Stop planning from scratch. <span className="text-gold" data-id="element-53" data-mp="1kzwvaesn7yxc">Walk into every class ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-54" data-mp="1l1zxryazfkiy">
          Six volumes, 59 Ready-Run Sessions, 29 worksheets and five bonuses —
          from first landings to full flow lines, for kids, teens and rec groups.
        </p>

        <div className="mt-7" data-id="element-55" data-mp="179tfo6o9r3gv">
          <Countdown size="sm" tone="dark" data-id="element-56" data-mp="17alahfa1kx63" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-57" data-mp="129xc28jhhe1u">
          <div data-id="element-58" data-mp="xcx6dyqjqdb9">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-59" data-mp="3vfop8wi95p97">Complete package</span>
            <span className="text-[15px] font-bold text-white" data-id="element-60" data-mp="40zfp9nsu5fw">The Parkour Class-Ready Megapack — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-61" data-mp="3lj25kb1nx48r">
            <span className="text-[15px] text-white/60 line-through" data-id="element-62" data-mp="3qfiv99oifqny">$97</span>
            <span className="font-display text-4xl leading-none text-white" data-id="element-63" data-mp="i0s42ybus9kp">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-64" data-mp="n04yc4520ixb">
          <CtaButton data-id="element-65" data-mp="mytuy5fitd6q">Yes, I want the Megapack — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-66" data-mp="81jdmfg75d33">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-67" data-mp="2srihacq7kzzw">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-68" data-mp="2xrmxe1n7fspl" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}